import React from "react";
import { StyleSheet, TouchableOpacity } from "react-native";
import { View } from "react-native-animatable";
import { MainText } from "./MainText";

interface Props {
  isSelected: boolean;
  underlineColor: string;
  onPress(): void;
  text: string;
  style?: {};
}

const styles = StyleSheet.create({
  underlineText: {
    borderRadius: 1,
    borderBottomWidth: 4,
  },
});

const TouchableUnderlineMediumText = ({
  onPress,
  isSelected,
  underlineColor,
  text,
  style = {},
}: Props) => {
  return (
    <TouchableOpacity onPress={onPress} style={style}>
      <MainText
        variant="l3-medium"
        color={isSelected ? "neutral.900" : "neutral.500"}
        paddingBottom="xxs"
        paddingTop="xxs"
      >
        {text}
      </MainText>
      <View
        style={[
          isSelected && styles.underlineText,
          isSelected && {
            borderBottomColor: underlineColor,
          },
        ]}
      ></View>
    </TouchableOpacity>
  );
};

export { TouchableUnderlineMediumText };
